import React from "react";
import Translate from "react-translate-component";
import AccountLogin from "./AccountLogin";
import WalletLogin from "./WalletLogin";
import WalletHeaderSelection from "../Registration/WalletHeaderSelection";
import AccountHeaderSelection from "../Registration/AccountHeaderSelection";
export default class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      activeWalletModel: true
    };
  }

  changeActiveModel(isActiveWallet) {
    this.setState({
      activeWalletModel: isActiveWallet
    });
  }

  render() {
    const {
      activeWalletModel
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "grid-block align-center registration-layout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink vertical text-center registration-selector"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "login.title",
      component: "p",
      className: "registration-title"
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "v-align login-page-selector"
    }, /*#__PURE__*/React.createElement("div", {
      className: `${!activeWalletModel ? "inactive-model-block" : ""} selection-block align-center plate`
    }, /*#__PURE__*/React.createElement("div", {
      className: "small-horizontal small-only-block"
    }, /*#__PURE__*/React.createElement(WalletHeaderSelection, {
      active: activeWalletModel,
      onChangeActive: () => this.changeActiveModel(true),
      loginPage: true
    }), /*#__PURE__*/React.createElement(AccountHeaderSelection, {
      active: !activeWalletModel,
      onChangeActive: () => this.changeActiveModel(false),
      forSmall: true,
      loginPage: true
    })), /*#__PURE__*/React.createElement(WalletLogin, {
      active: activeWalletModel,
      onChangeActive: () => !activeWalletModel ? this.changeActiveModel(true) : null,
      goToAccountModel: () => this.changeActiveModel(false),
      history: this.props.history
    })), /*#__PURE__*/React.createElement("div", {
      className: `${activeWalletModel ? "inactive-model-block" : ""} selection-block align-center plate`
    }, /*#__PURE__*/React.createElement("div", {
      className: "small-horizontal small-only-block"
    }, /*#__PURE__*/React.createElement(WalletHeaderSelection, {
      active: activeWalletModel,
      onChangeActive: () => this.changeActiveModel(true),
      forSmall: true,
      loginPage: true
    }), /*#__PURE__*/React.createElement(AccountHeaderSelection, {
      active: !activeWalletModel,
      onChangeActive: () => this.changeActiveModel(false),
      loginPage: true
    })), /*#__PURE__*/React.createElement(AccountLogin, {
      active: !activeWalletModel,
      history: this.props.history,
      onChangeActive: () => activeWalletModel ? this.changeActiveModel(false) : null,
      goToWalletModel: () => this.changeActiveModel(true)
    }))))));
  }

}